import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../App.js'
import './index.css'
import COLORS  from '../../colors'
import { Button, TextField, makeStyles } from '@material-ui/core'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'

const useStyles = makeStyles((theme) => ({
	input: {
	  	background: COLORS.gray,
	  	borderRadius: '1rem',
	},
	saveBtn:{
		width:'90%', 
        color:"#fff", 
    	fontWeight: 'bold', 
        backgroundColor: COLORS.blue, 
        textTransform: 'none',
		margin:'1rem',
		"&:hover": {
			backgroundColor: COLORS.blue
	  	} 
	}
  }));

const ModalEditQuantityNumber = ({ popup, editedItem, cartItems, onClose }) => {
	const { incrementQN } = useContext(AuthContext)
	const [ quantity, setQuantity ] = useState('')
	const [ keypad, setKeypad ] = useState(false)
	const [ isDisabled, setIsDisabled ] = useState(true)
	const [ width, setWidth ] = useState(window.innerWidth);
	const [ height, setHeight ] = useState(window.innerHeight);
	const classes = useStyles()
	const currDate = new Date()
	const handleQuantity = (event) => {
				event.persist()
				setQuantity(event.target.value.replace(/[^0-9]/g, ''))
	}

	useEffect(()=>{
			if(editedItem.quantity!==undefined){
		 			setQuantity(editedItem.quantity)
			}
	},[onClose])

	useEffect(()=>{
		if(quantity===editedItem.quantity||quantity===''||parseInt(quantity)===0){
						setIsDisabled(true)
		}else{
						setIsDisabled(false)
		}
	},[quantity])

	useEffect(()=>{
	 	function hideKeypad(){
			setWidth(window.innerWidth);
    		setHeight(window.innerHeight);	 	 
		}
	 	window.addEventListener('resize', hideKeypad, false)
	 	return () => window.removeEventListener('resize', hideKeypad, false);
	 },[])

	const handleEditQuantity = () => {
		console.log("Handle edit quantity...", editedItem, quantity)
		var sum=0
		for(let num in cartItems){
				if(cartItems[num].item.id===editedItem.item.id){
						cartItems[num].quantity=parseInt(quantity)
				}
				sum+=cartItems[num].quantity
		}
		incrementQN(sum)
		onClose()
		setQuantity('')
	}

	const handleEnterPress = (event) => {
		if(event.key=='Enter'&&!isDisabled){
			handleEditQuantity()
		}
	}

	const handleClose = () => {
		onClose()
		setQuantity('')
	}

	const handleName = (itemName) => {

		var newName = ""
		if(itemName.length>19)
		{
			newName = itemName.substring(0,19)+'...'
		}else
		{
			newName = itemName
		}

		return newName
	}

	if (!popup) return null
    return (
    			<div className="modal">
					<div className="overlay-article-modal" />
					<div className="modal-edit-qn-body" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'18rem':'40%'):'45%'}}>
						<div className="modal-edit-qn">	
							{(!keypad||height>500)?<div className="modal-edit-qn-title">Promijeni broj komada</div>:
								<div className="modal-edit-qn-title-on-keypad">Promijeni broj komada</div>}
							{(!keypad||height>500)&&<Close className="modal-edit-qn-close-btn" onClick={() => handleClose()}/>}
						</div>
						<div className="modal-edit-qn-heading">
							<div className="modal-edit-qn-heading-name">{handleName(editedItem.item.name)}</div>
							<div className="modal-edit-qn-heading-price">{editedItem.item.price} EUR</div>
						</div>
						<TextField  label="Broj komada" 
								    variant="outlined"
									type="number"
									style={{
										width:'90%'
									}}
								    InputProps = {{
										className: classes.input,
									}}
									value={quantity}
									onFocus={()=>setKeypad(true)}
									onBlur={()=>setKeypad(false)}
									onKeyPress={(event)=>handleEnterPress(event)}
									onChange = { (event) => handleQuantity(event) }	        
						/>
						{(!keypad||height>500)&&<Button size="large" 
                 									variant="contained"
													className={classes.saveBtn}
													disabled={isDisabled}
													onClick={() => handleEditQuantity()}
						>SPREMI</Button> }
						{(!keypad||height>500)&&<Button size="large" 
                 										variant="contained"
                 										style={{ width:'90%', 
                             									color:"#000", 
                             									fontWeight: 'bold', 
                             									backgroundColor:'#fff',
																marginBottom:'1rem',
																border: '2px solid #2F2F5B', 
                     		 									textTransform: 'none',
																"&:hover": {
																	backgroundColor: '#fff'
															  	} 
                       									}}
														 
														onClick={() => handleClose()}
												>ODUSTANI</Button>}	
					</div>
    			</div>
	)
}

export default ModalEditQuantityNumber
